import React, { useEffect, useState, useRef } from 'react'
import { Helmet } from 'react-helmet';
import '../../styles/Home.css'


function UIUC() {
    const [videos, setVideos] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const videoItemRefs = useRef([]);

    useEffect(() => {
      // Set the document title
      document.title = "Zuckerberg";

      fetch('https://raw.githubusercontent.com/aaryamanpatel/public/main/json/web_uiuc.json')
        .then(response => response.json())
        .then(data => {
          let allVideos = [];
          for (let year in data) {
            allVideos = allVideos.concat(data[year]);
          }
  
          // Fisher-Yates (Knuth) Shuffle algorithm
          let currentIndex = allVideos.length, temporaryValue, randomIndex;
  
          // While there remain elements to shuffle...
          while (0 !== currentIndex) {
  
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
  
            // And swap it with the current element.
            temporaryValue = allVideos[currentIndex];
            allVideos[currentIndex] = allVideos[randomIndex];
            allVideos[randomIndex] = temporaryValue;
          }
  
          setVideos(allVideos);
        //   console.log(allVideos);
        });
    }, []);

    useEffect(() => {
        const handleScroll = () => {
          const screenHeight = window.innerHeight;
          videoItemRefs.current.forEach(ref => {
            if (ref) {
              const rect = ref.getBoundingClientRect();
              const elementCenter = rect.top + rect.height / 2;
    
              if (elementCenter > screenHeight / 4 && elementCenter < (3 * screenHeight) / 4) {
                ref.classList.add('video-title-visible');
              } else {
                ref.classList.remove('video-title-visible');
              }
            }
          });
        };
    
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Initial call to handle initial state
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, [videos]);
  
  function decodeHtml(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
  }

  return (
    <div className="full-container">
      <Helmet>
        <title>UIUC on 'Oldplay'</title>
        <meta property="og:title" content="UIUC on 'Oldplay'" />
        <meta name="twitter:title" content="UIUC on 'Oldplay'" />
        {/* Add more meta tags as needed */}
      </Helmet>
      <div className='fade-in'>
        <h1 className="title">University of Illinois at Urbana-Champaign (UIUC)</h1>
      </div>
      <div className="search-container">
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-bar"
        />
        <svg
          className="search-icon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          fill="black"
          width={15}
        >
          <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
        </svg>
      </div>
      <div className="video-grid">
        {videos
          .filter(video =>
            video.title.toLowerCase().includes(searchTerm.toLowerCase())
          )
          .map((video, index) => (
            <div key={index} className="video-item fade-in" ref={el => videoItemRefs.current[index] = el}>
              <div
                style={{
                  backgroundImage: `url(${video.thumbnail})`,
                }}
                className="video-thumbnail"
                onClick={() =>
                  window.open(
                    `${video.url}`,
                    "_blank"
                  )
                }
              />
              <div className="video-title">
                {decodeHtml(video.title)}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default UIUC;